import React from "react";
import ValueFiltersPanel from "views/marketplace/merchandising/filter/valueFiltersPanel";

// The Price tab's four free numeric inputs — one filter each, validated together.
export const PRICE_FILTER_ITEMS = [
    {"@type": "PriceMin", id: "priceMin", unit: "€", labelId: "merchandising.show.label.filters.price.min"},
    {"@type": "PriceMax", id: "priceMax", unit: "€", labelId: "merchandising.show.label.filters.price.max"},
    {"@type": "DiscountMin", id: "discountMin", unit: "%", labelId: "merchandising.show.label.filters.discount.min"},
    {"@type": "DiscountMax", id: "discountMax", unit: "%", labelId: "merchandising.show.label.filters.discount.max"},
];

export default function PriceFilterPanel() {
    return <ValueFiltersPanel items={PRICE_FILTER_ITEMS} applyLabelId={"merchandising.show.label.filters.price.apply"}/>;
}
